import React, { useEffect, useState, useRef } from 'react';
import { Trans } from 'react-i18next';
import classes from './classes.module.scss';
import withPGTranslation from '../../../../config/withPGTranslation';
import VideoPlayer from '../../../video_player';
import { isMiddleMobile } from '../../../../config/util';
import { isKA } from '../../../../../common/config/utils';
import { heroBannerSources } from './hero_banner_sources';
import HeroSearch from './hero_search';

const {
  thumbMobile, videoMobile, thumbDesktop, videoDesktop
} = heroBannerSources();

const getHeroVideoUrl = () => {
  if (isMiddleMobile()) return videoMobile;
  return videoDesktop;
};

const getHeroPosterUrl = () => {
  if (isMiddleMobile()) return thumbMobile;
  return thumbDesktop;
};

function HeroBanner({
  itemProp: _itemProp, loading, t
}) {
  const [videoUrl, setVideoUrl] = useState(null);
  const [posterUrl, setPosterUrl] = useState(getHeroPosterUrl());
  const videoRef = useRef();

  const handleResize = () => {
    if (videoUrl) setVideoUrl(getHeroVideoUrl());
    setPosterUrl(getHeroPosterUrl());
  };

  useEffect(() => {
    let timeout = null;
    if (!loading && !videoUrl) {
      timeout = setTimeout(() => {
        setVideoUrl(getHeroVideoUrl());
      }, 500);
    }
    return () => {
      if (timeout) {
        clearTimeout(timeout);
      }
    };
  }, [loading]);

  useEffect(() => {
    window.addEventListener('resize', handleResize, false);
    return () => {
      window.removeEventListener('resize', handleResize, false);
    };
  }, [videoUrl]);

  useEffect(() => {
    const video = videoRef.current;
    if (video) {
      const resizeObserver = new ResizeObserver(handleResize);
      resizeObserver.observe(video);
      return () => {
        resizeObserver.disconnect();
      };
    }
    return () => {};
  }, [videoRef.current]);

  const renderFindYourWay = () => {
    if (!isKA()) return null;
    return (
      <>
        <p className={ classes.findYourWayContainer }>
          <Trans
            i18nKey= "find_your_way_to_love_and_happiness"
          />
        </p>
        <p className={ classes.findYourWayMobileContainer }>
          <Trans
            i18nKey= "find_your_way_to_love_and_happiness_mobile"
          />
        </p>
      </>
    );
  };

  const renderHeroBanner = () => (
    <div className={ classes.bannerContainer } data-testid="hero-banner">
      <div className={ classes.bannerContent }>
        <div className={ classes.bannerTitleContainer }>
          <h1 className={ classes.bannerTitle }>
            <Trans
              i18nKey= "hero_banner_title"
              components={ {
                bold: <b key="bold1" className={ classes.boldBanner } />
              } }
            />
          </h1>
          <h1 className={ classes.bannerTitleMobile }>
            <Trans
              i18nKey= "hero_banner_title_mobile"
              components={ {
                bold: <b key="bold2" className={ classes.boldBanner } />
              } }
            />
          </h1>
          { renderFindYourWay() }
        </div>
        <div className={ classes.searchContainer } data-testid="hero-banner-search">
          <HeroSearch t={ t } />
        </div>
      </div>
      <div className={ classes.bannerVideoContainer }>
        {!videoUrl && (
          <div
            className={ classes.bannerPoster }
            style={ {
              '--poster-desktop': `url(${ thumbDesktop })`,
              '--poster-mobile': `url(${ thumbMobile })`
            } }
          />
        )}
        {videoUrl && (
          <VideoPlayer
            videoUrl={ videoUrl }
            videoRef={ videoRef }
            poster={ posterUrl }
            controls={ false }
            muted
            className={ classes.bannerVideoPlayer }
            loop
          />
        )}
      </div>
    </div>
  );

  return renderHeroBanner();
}

export default withPGTranslation(HeroBanner);
